import { removeNamespace } from '@/utils/helpers'
import TenantService from '@/services/tenant.service'
import * as cloneDeep from 'lodash.clonedeep'

export const TENANTS_TYPES = {
  mutations: {
    SET_LOADING: 'tenants/SET_LOADING',
    SET_PAGED_TENANTS: 'tenants/SET_PAGED_TENANTS',
    SET_TOTAL_TENANTS_COUNT: 'tenants/SET_TOTAL_TENANTS_COUNT',
    SET_TENANT_TABLE_OPTIONS: 'tenants/SET_TENANT_TABLE_OPTIONS',
    SET_ALL_TENANTS: 'tenants/SET_ALL_TENANTS'
  },
  actions: {
    fetchTenantsPaged: 'tenants/fetchTenantsPaged',
    fetchAllTenants: 'tenants/fetchAllTenants'
  }
}

const _types = removeNamespace('tenants', TENANTS_TYPES)

const state = () => ({
  loading: false,
  tenantTableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  tenantSearchOptions: {
    keyword: ''
  },
  pagedTenants: [],
  allTenants: [],
  totalTenantsCount: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_TENANTS] (state, pagedResult) {
    state.pagedTenants = pagedResult
  },
  [_types.mutations.SET_TOTAL_TENANTS_COUNT] (state, count) {
    state.totalTenantsCount = count
  },
  [_types.mutations.SET_TENANT_TABLE_OPTIONS] (state, options) {
    state.tenantTableOptions = options
  },
  [_types.mutations.SET_TENANT_SEARCH_OPTIONS] (state, options) {
    state.tenantSearchOptions = cloneDeep(options)
  },
  [_types.mutations.SET_CURRENT_TENANT] (state, id) {
    state.currentTenantId = id
  },
  [_types.mutations.SET_ALL_TENANTS] (state, items) {
    state.allTenants = items
  }
}

const actions = {
  [_types.actions.fetchTenantsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page } = state.tenantTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return TenantService.fetchTenantsPaged(skipCount, maxResultCount, state.tenantSearchOptions.keyword)
      .then((res) => {
        commit(_types.mutations.SET_PAGED_TENANTS, res)
        commit(_types.mutations.SET_TOTAL_TENANTS_COUNT, res.length)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchAllTenants] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    return TenantService.fetchTenantsPaged(0, 100, '')
      .then((res) => {
        commit(_types.mutations.SET_ALL_TENANTS, res)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
